import LottieWidgetView from './LottieWidgetView.vue';

export const type = 'lottie';
export const view = LottieWidgetView;

export function builder() {
  return {
    type,
    left: 0,
    top: 0,
    rotate: 0,
    height: 200,
    width: 300,
    content: '',
    loop: true,
  };
}
